import { memo } from "react";
import PropTypes from "prop-types";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

import SelectedFilters from "components/CasesTable/SelectedFilters";
import { MachineFilter } from "components/CasesTable/Filters/MachineFilter";
import { SiteFilter } from "components/CasesTable/Filters/SiteFilter";
import { MachineStatusFilter } from "components/CasesTable/Filters/MachineStatusFilter";
import { OutcomeFilter } from "components/CasesTable/Filters/OutcomeFilter";
import { DelayReasonFilter } from "components/CasesTable/Filters/DelayReasonFilter";
import { StatusFilter } from "components/CasesTable/Filters/StatusFilter";

export const DownDerateTableFilters = memo(function DownDerateTableFilters(
  props
) {
  const { filters, setFilters, clearFilters } = props;

  const clearAllFilters = () => {
    if (filters && Object.entries(filters).length > 0) {
      clearFilters();
    }
  };
  const onSetFilters = (values, title) => setFilters(title, values);
  return (
    <>
      <FiltersPaper>
        <PaperHeader>Filtering</PaperHeader>
        <SelectContainer>
          <SelectWrappers>
            <SiteFilter
              selectedSites={filters["Site"] ?? []}
              onChangeSelectedSites={values => onSetFilters(values, "Site")}
              showChips={false}
            />
          </SelectWrappers>
          <SelectWrappers>
            <MachineFilter
              selectedMachines={filters["Machine"] ?? []}
              selectedSites={filters["Site"] ?? []}
              onChangeSelectedMachines={values =>
                onSetFilters(values, "Machine")
              }
              showChips={false}
            />
          </SelectWrappers>
          <SelectWrappers>
            <MachineStatusFilter
              selectedMachineStatuses={filters["Machine Status"] ?? []}
              onChangeSelectedMachineStatuses={values =>
                onSetFilters(values, "Machine Status")
              }
              showChips={false}
            />
          </SelectWrappers>
          <SelectWrappers>
            <OutcomeFilter
              selectedOutcomes={filters["Outcome"] ?? []}
              onChangeSelectedOutcomes={values =>
                onSetFilters(values, "Outcome")
              }
              showChips={false}
            />
          </SelectWrappers>
          <SelectWrappers>
            <DelayReasonFilter
              selectedDelayReasons={filters["Delay Reason"] ?? []}
              onChangeSelectedDelayReasons={values =>
                onSetFilters(values, "Delay Reason")
              }
              showChips={false}
            />
          </SelectWrappers>
          <SelectWrappers>
            <StatusFilter
              title="Case Status"
              selectedStatuses={filters["Case Status"] ?? []}
              onChangeSelectedStatuses={values =>
                onSetFilters(values, "Case Status")
              }
              showChips={false}
            />
          </SelectWrappers>
        </SelectContainer>
        <Stack direction="row" gap={1.5} mt={1}>
          <SelectedFilters
            selectedFilterValues={filters}
            onSetFilters={onSetFilters}
          />
          <ClearFiltersButton
            variant="outlined"
            color="primary"
            onClick={clearAllFilters}
            sx={{ m: 0 }}
          >
            Clear Filters
          </ClearFiltersButton>
        </Stack>
      </FiltersPaper>
    </>
  );
});

DownDerateTableFilters.propTypes = {
  filters: PropTypes.object.isRequired,
  setFilters: PropTypes.func.isRequired,
  setFilterGroups: PropTypes.func,
  clearFilters: PropTypes.func.isRequired,
  isDDTPage: PropTypes.bool
};

const FiltersPaper = styled(Paper)`
  padding: 16px;
  margin-bottom: 20px;
`;

const SelectContainer = styled("div")`
  display: flex;
  flex-wrap: wrap;
  margin-left: -5px;
  margin-right: -5px;
  justify-content: end;
`;

const SelectWrappers = styled("div")`
  flex: 1 1 8%;
  margin: 5px;
  @media (max-width: 1900px) {
    flex: 1 1 18%;
  }
  @media (max-width: 1200px) {
    flex: 1 1 45%;
  }
  @media (max-width: 960px) {
    flex: 1 1 18%;
  }
  @media (max-width: 860px) {
    flex: 1 1 45%;
  }
`;

const ClearFiltersButton = styled(Button)`
  min-width: 140px;
  margin: 12px 0 0 10px;
  max-height: 40px;
`;

const PaperHeader = styled(Typography)`
  font-size: 18px;
  color: #555555;
`;
